<template>
  <input
    ref="slider"
    :class="className"
    type="range"
    :min="min"
    :max="max"
    :value="value"
    @input="emit($event.target.value)"
    @touchmove="touchmove"
    @touchstart="touchmove"
  >
</template>

<script>
export default {
  name: 'TouchRange',
  props: {
    className: { type: String, default: '' },
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 1 },
  },
  computed: {
    range() {
      return this.max - this.min;
    },
  },
  methods: {
    emit(val) {
      this.$emit('input', Number(val));
    },
    touchmove(e) {
      e.preventDefault();
      const cw = e.target.clientWidth;
      const rate = Math.max(0, Math.min(cw, e.touches[0].pageX - this.$refs.slider.getBoundingClientRect().left)) / cw;
      this.emit(rate * this.range + this.min);
    },
  },
};
</script>
